const loginRouter = {
  path: '',
  component: () => import(/* webpackChunkName: "login" */ '@/pages/loginNavTop/layout'),
  meta: { title: '注册登录' },
  children: [
    {
      path: '/login', // 登录首页
      name: 'login',
      meta: { title: '登录', hiddenNav: true },
      component: () => import(/* webpackChunkName: "login" */ '@/pages/loginNavTop')
    },
    {
      path: '/forgotPassword', // 忘记密码
      name: 'forgotPassword',
      meta: { title: '忘记密码' },
      component: () => import(/* webpackChunkName: "login" */ '@/pages/loginNavTop/forgotPassword')
    },
    {
      path: '/register', // 注册
      name: 'register',
      meta: { title: '注册' },
      component: () => import(/* webpackChunkName: "login" */ '@/pages/loginNavTop/register')
    }
  ]
}

export default loginRouter
